import createRepository from '~/api/repositories'

export default (ctx, inject) => {
  inject('repositories', createRepository(ctx.$axios))
}
